import _Model from "./_Model";

export default class ConfigurationAccessories extends _Model {
  constructor(json) {
    super(json);
    this.softwareList =  ConfigurationAccessories.getMappedOrDefault(json, 'softwareList', [], data => (data || []).map(d => d));
  }
}
